import {
  errorUnlessOk,
  buildRequestWithAuth,
  headersBackendSeguros,
} from "./utils";
import environment from "~libs/environment";
import { GetStatisticsCotizacionResponse } from "./types";

const estadisticas = () => {
  return {
    getEstadisticas: (): Promise<GetStatisticsCotizacionResponse> => {
      const request = buildRequestWithAuth("GET", null, headersBackendSeguros);
      const url = environment.segurosUrl + "/estadisticas/cotizaciones";

      return fetch(url, request)
        .then(errorUnlessOk)
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
  };
};

export { estadisticas };
